import { createContext } from 'react';
import { ColorMode } from '@/config/theme/useTheming';

export const ColorModeContext = createContext<{ mode: ColorMode; toggleColorMode: () => void; isDarkMode: boolean }>({
  toggleColorMode: () => null,
  mode: 'light',
  isDarkMode: false,
});
